import axios, { AxiosResponse } from 'axios';
import { User } from '../../constants';
import { api } from '../../../v2.snapshot/js/jcs';

export function resetPassword(passwordResetToken: string, password: string): Promise<AxiosResponse<User>> {
  const url = `${api.url_v3}/resetpassword`;
  return axios.post(url, { passwordResetToken, password }, { withCredentials: true });
}
